"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageFont = exports.contrast = exports.paletteColors = exports.spacing = exports.breakpoints = void 0;
var neutralTheme_1 = require("./neutralTheme");
var csTheme_1 = require("./csTheme");
var core_1 = require("@material-ui/core");
exports.breakpoints = (_a = core_1.createMuiTheme(), _a.breakpoints), exports.spacing = _a.spacing;
exports.paletteColors = function (theme) {
    return (theme === null || theme === void 0 ? void 0 : theme.theme) === 'neutralLight' ? neutralTheme_1.paletteColorsNeutral : csTheme_1.paletteColorsCs;
};
exports.contrast = function (theme) {
    return (theme === null || theme === void 0 ? void 0 : theme.theme) === 'neutralLight' ? neutralTheme_1.contrastNeutral : csTheme_1.contrastCS;
};
// const defaultTheme = (): Theme => createMuiTheme()
exports.languageFont = function (language) {
    var fonts = ['tr', 'pl', 'ro'];
    var font = {};
    if (fonts.includes(language === null || language === void 0 ? void 0 : language.toLowerCase())) {
        font = {
            fontFamily: 'Arial',
            h1: {
                fontFamily: 'Arial',
                fontWeight: 300,
                fontSize: '96px',
                lineHeight: '127px',
                letterSpacing: '-1.5px',
            },
            h2: { fontFamily: 'Arial', fontWeight: 300, fontSize: '60px', lineHeight: '79px', letterSpacing: '-0.5px' },
            h3: { fontFamily: 'Arial', fontSize: '48px', lineHeight: '63px' },
            h4: { fontFamily: 'Arial', fontSize: '34px', lineHeight: '45px', letterSpacing: '0.25px' },
            h5: { fontFamily: 'Arial', fontSize: '24px', lineHeight: '32px' },
            h6: { fontFamily: 'Arial', fontWeight: 500, fontSize: '20px', lineHeight: '26px', letterSpacing: '0.15px' },
            subtitle1: { fontFamily: 'Arial', fontSize: '16px', lineHeight: '19px', letterSpacing: '0.15px' },
            subtitle2: {
                fontFamily: 'Arial',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '16.41px',
                letterSpacing: '0.1px',
            },
            body1: { fontFamily: 'Arial', fontSize: '18px', lineHeight: '200%', letterSpacing: '0.5px' },
            body2: { fontFamily: 'Arial', fontSize: '14px', lineHeight: '16px', letterSpacing: '0.25px' },
            button: { fontFamily: 'Arial', fontWeight: 500, fontSize: '14px', letterSpacing: '1.25px' },
            caption: { fontFamily: 'Arial', fontSize: '12px', lineHeight: '14px', letterSpacing: '0.4px' },
            overline: { fontFamily: 'Arial', fontSize: '10px', lineHeight: '12px', letterSpacing: '1.5px' },
        };
    }
    return font;
};
//# sourceMappingURL=theme.js.map